import { TaskService } from './../task.service';
import { TaskListComponent } from './task-list.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  DxDataGridModule, DxChartModule, DxBulletModule, DxTemplateModule, DxPopupModule,

} from 'devextreme-angular';
import { DevEpressCommonModule } from 'src/app/dev-epress-common.module';
import { TaskListRoutingModule } from './task-list-routing.module';
import { TaskPopupModule } from '../task-popup/task-popup.module';
import { ContainerComponent } from 'src/app/components/container/container.component';
import { DxTableControllerDirective } from 'src/app/directives/dx-table-controller.directive';



@NgModule({
  declarations: [TaskListComponent],
  imports: [
    CommonModule,
    TaskListRoutingModule,
	ContainerComponent,
	DxTableControllerDirective,
    DxDataGridModule,
    DxChartModule,
    DevEpressCommonModule,
    DxDataGridModule,
    DxBulletModule,
    DxTemplateModule,
    TaskPopupModule,
    DxPopupModule
  ], providers: [TaskService]
})
export class TaskListModule { }
